import { render, staticRenderFns } from "./HomeFeaturedNews.vue?vue&type=template&id=59c1baba&"
import script from "./HomeFeaturedNews.vue?vue&type=script&lang=js&"
export * from "./HomeFeaturedNews.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeaturedNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports